import '/src/scripts/_global';

import '/src/components/next/globals/navbar/navbar';
import '/src/components/next/blocks/feedback/feedback';
import '/src/components/next/blocks/contactus/contactus';

import { updateScrollOut } from '/src/scripts/es-modules/scroll-reveal';

import allSolutions from '../requires/solution-list';

function updatePage() {
  const { hash } = location;

  const prevLink = document.querySelector('.posts-menu__link_active');
  const nextLink =
    document.querySelector(`.posts-menu__link[href="${hash}"]`) ||
    document.querySelector('.posts-menu__link:first-child');

  prevLink.classList.remove('posts-menu__link_active');
  nextLink.classList.add('posts-menu__link_active');

  document.querySelector('.posts').innerHTML = allSolutions
    .filter(
      ({ groupKey }) => !hash || hash === '#all' || groupKey === hash.slice(1),
    )
    .reduce((accumulator, item) => {
      const { url, img, title, about } = item;
      const [src] = img.split('.');

      return `${accumulator}
          <a
            href="${url}"
            class="post posts__item | wow wow_fade-up"
          >
            <picture class="post__thumb">
              <source
                type="image/webp"
                srcset="${src}.webp, ${src}@2x.webp 2x">
              <img
                alt=""
                src="${src}.jpg"
                class="post__thumb-src"
                srcset="${src}@2x.jpg 2x">
            </picture>

            <div class="post__body">
              <div class="post__title h4">${title}</div>

              ${about ? `<div class="post__about">${about}</div>` : ''}
            </div>
          </a>
        `;
    }, '');
}

const initialHash = location.hash;

if (initialHash && initialHash !== '#all') {
  updatePage();
}

window.addEventListener(
  'hashchange',
  () => {
    updatePage();
    updateScrollOut();
  },
  false,
);
